import { JYWhiteBoardView } from './src/JYWhiteBoardView.native';
import JYWhiteBoardManager from './src/JYWhiteBoardManager.native';
export * from './src/Types';

export default JYWhiteBoardView;
export { JYWhiteBoardManager };
